import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, TextField, Autocomplete } from '@mui/material';
import { ReportService } from '../../service/ReportService';
import { UserService } from '../../service/UserService';

const AdminDashboard: React.FC = () => {
  const [usageData, setUsageData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [users, setUsers] = useState<any[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedUserId) {
        try {
          const response: any = await ReportService.getCustomerUsage(selectedUserId);
          setUsageData(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchData();
  }, [selectedUserId]);


  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);


    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }


    const timeout = setTimeout(async () => {
      if (value) {
        try {
          const response = await UserService.getUsersByEmail(value);
          setUsers(response.data || []);
        } catch (error) {
          console.error('Error fetching users:', error);
          setUsers([]);
        }
      } else {
        setUsers([]);
      }
    }, 1000);

    setDebounceTimeout(timeout);
  };

  const handleUserSelect = (user: any) => {
    setSelectedUserId(user.id);
    setSearchTerm(user.email);
    setUsers([]);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#1e1e1e',
        color: '#ffffff',
        padding: '20px',
        borderRadius: '8px',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Customer Usage Data
      </Typography>
      <Autocomplete
        options={users}
        getOptionLabel={(option) => option.email}
        onChange={(event, newValue) => {
          if (newValue) {
            handleUserSelect(newValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Search by email..."
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{
              backgroundColor: '#333',
              color: '#ffffff',
              marginBottom: '20px',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#444',
                },
                '&:hover fieldset': {
                  borderColor: '#00ff00',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#00ff00',
                },
              },
            }}
          />
        )}
      />
      <TableContainer
        component={Paper}
        sx={{
          border: '1px solid #444',
          backgroundColor: 'transparent',
        }}
      >
        <Table sx={{ backgroundColor: '#000000' }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Label
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Used Tokens
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Week
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Month
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Year
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#333',
                  color: '#00ff00',
                  fontFamily: 'Courier New, Courier, monospace',
                  textAlign: 'left',
                }}
              >
                Node Runs
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usageData.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.label}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.usedTokens}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.week}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.month}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.year}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: '1px solid #444',
                    fontFamily: 'Courier New, Courier, monospace',
                    color: '#ffffff',
                  }}
                >
                  {row.nodeRuns}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AdminDashboard;